document.addEventListener("DOMContentLoaded", function () {
    class YGTab extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.style.overflowX = 'auto';
        this.style.whiteSpace = 'nowrap';

        const items = this.querySelectorAll('.yg-tab-item');

        items.forEach(item => {
          item.style.display = 'inline-flex';

          item.addEventListener('click', () => {
            // 切换 active 类
            items.forEach(i => i.classList.remove('active'));
            item.classList.add('active');

            // 正确计算目标相对 wrapper 左边的距离
            const wrapperRect = this.getBoundingClientRect();
            const itemRect = item.getBoundingClientRect();
            const delta = itemRect.left - wrapperRect.left;

            // 当前 scrollLeft 加上这个 delta，就能把 item 滚动到最左边
            this.scrollTo({
              left: this.scrollLeft + delta -12,
              behavior: 'smooth'
            });
          });
        });
      }
    }

    customElements.define('yg-tab-1', YGTab);
  });

document.addEventListener('DOMContentLoaded', function () {
    class Tab extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        // 选择模板
        const templateTable = {
          // Impact模板
          Impact: {
            sectionListClassName: '#main .shopify-section',
            addToCartClassName: '.button--secondary[is="custom-button"]',
            variantBlock: '.variant-picker',
            headerWrpper: '.header__wrapper',
            // 变体价格的渲染是否有snippet组件渲染
            renderTag: true,
            priceList: '.product-info__price .price-list',
          },
          // Modular模板
          Modular: {
            sectionListClassName: '#MainContent .shopify-section',
            addToCartClassName: '.product__form-buttons .product__form-submit',
            variantBlock: '.product__form .product__form-block--swatches',
            headerWrpper: '.site-header',
            // 变体价格的渲染是否有snippet组件渲染
            renderTag: false,
            originalPrice: '.product__price[data-price-wrapper] .product__price__sale',
            salePrice: '.product__price[data-price-wrapper] span',
          },
          // Vision模板
          Vision: {
            sectionListClassName: '#main-content .shopify-section',
            addToCartClassName: '#AddToCart',
            variantBlock: '.variations',
            headerWrpper: '#header',
            // 变体价格的渲染是否有snippet组件渲染
            renderTag: true,
            priceList: '.product-price-container .no-js-hidden',
          },
          // Focal模板
          Focal: {
            sectionListClassName: '#main .shopify-section',
            addToCartClassName: '#AddToCart',
            variantBlock: '.product-form__variants',
            headerWrpper: '.header',
            // 变体价格的渲染是否有snippet组件渲染
            renderTag: false,
            originalPrice: '.price-list .price--compare .money',
            salePrice: '.price-list span .money',
          },
          // Dawm
          Dawm: {
            sectionListClassName: '#MainContent .shopify-section',
            addToCartClassName: '#qstomizer-product-button',
            variantBlock: 'variant-selects',
            headerWrpper: '.header',
            // 变体价格的渲染是否有snippet组件渲染
            renderTag: false,
            originalPrice: '.price__sale .price-item--regular',
            salePrice: '.price__sale .price-item--sale',
          },
          // Concept
          Concept: {
            sectionListClassName: '#MainContent .shopify-section',
            headerWrpper: '.header',
            addToCartClassName: '.product-form__submit[name="add"]',
          },
        };

        // 获取模板的名字
        const $tabBox = this;

        const themeName = $tabBox.dataset.themeName;

        // 根据不同模板传入不同的值
        this.template(templateTable[themeName]);
      }

      // 点击tab栏滑动到指定位置
      scrollSpecifiedPosition($productTab, $sectionList, $tabBox) {
        $productTab.forEach(function (e) {
          e.onclick = function () {
            // 获取点击项的data-point属性值
            let point = e.getAttribute('data-point');
            let number = e.getAttribute('data-section-number');

            // 遍历ygProductTab，移除所有激活类
            $productTab.forEach((a) => {
              a.classList.remove('active');
            });

            if (number) {
              let pointDom;

              // Reviews 直接定位到 Judge.me 评价组件
              if (e.textContent.trim().toLowerCase() === 'reviews') {
                pointDom =
                  document.querySelector('#judgeme_product_reviews') ||
                  document.querySelector('.jdgm-widget') ||
                  document.querySelector('.shopify-section[id$="__apps"]');
              } else {
                // 其他 Tab 继续按 Section Number 定位
                pointDom = $sectionList[number];
              }

              if (!pointDom) return;

              // 顶部主导航 + 产品页小导航的预留距离
              const headerOffset =
                (parseInt($tabBox.style.top) || 0) +
                $tabBox.getBoundingClientRect().height +
                20;

              const pointTop =
                pointDom.getBoundingClientRect().top +
                window.scrollY -
                headerOffset;

              window.scrollTo({
                top: pointTop,
                behavior: 'smooth',
              });
            }
          };
        });
      }

      // 设置tab固定时的top位置
      setTabPosition($headerSection, $tabBox) {
        let scrollTimer;
        window.addEventListener('scroll', function () {
          let { height, top } = $headerSection.getBoundingClientRect();
          
          
          // 剩下的代码保持不变
          if ($headerSection) {
            let btnBoxTop = height + top >= 0 ? height - 1 + top : 0;
            
            
            $tabBox.parentNode.parentNode.style.top = btnBoxTop + 'px';
          }
        });

        window.addEventListener('resize', function () {
          // 当窗口大小改变时，重新计算宽度
          let { height, top } = $headerSection.getBoundingClientRect();
          if ($headerSection) {
            let btnBoxTop = height + top >= 0 ? height - 1 + top : 0;
            $tabBox.parentNode.parentNode.style.top = btnBoxTop + 'px';
          }
        });
      }

      // 切换tab栏active项
      toggleActieTab($productTab, $sectionList, $productTabContainer) {
        const debounce = (func, delay) => {
          let timeout;
          return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
              func.apply(this, args);
            }, delay);
          };
        };

        const windowHeight = window.innerHeight;

        window.addEventListener('scroll', () => {
          $sectionList.forEach((item) => {
            if (item.getBoundingClientRect().top - (windowHeight * 1) / 2 < 0) {
              $productTab.forEach((productTab) => {
                if (item.getAttribute('data-section-number') == productTab.getAttribute('data-section-number')) {
                  $productTab.forEach((ele) => {
                    ele.classList.remove('active');
                  });
                  scrollProductTabContainer(productTab.offsetLeft - 20);
                  productTab.classList.add('active');
                }
              });
            }
          });
        });

        const scrollProductTabContainer = debounce((left) => {
          $productTabContainer.scrollTo({ left, behavior: 'smooth' });
        }, 300);

        $sectionList.forEach(function (Section, i) {
          Section.setAttribute('data-section-number', i);
          // intersectionObserver.observe(Section);
        });
      }

      template(templateName) {
        // 整个tab大盒子
        const $tabBox = this;

        // 导航栏
        const $productTabContainer = this.querySelector('.yg-tab-frame');
        const $productTab = this.querySelectorAll('.yg-tab-frame li');

        // 所有section分区
        const $sectionList = document.querySelectorAll(templateName.sectionListClassName);
        

        // 头部
        const $headerWrpper = document.querySelector(templateName.headerWrpper);

        // 点击tab栏滑动到指定位置
        this.scrollSpecifiedPosition($productTab, $sectionList, $tabBox);

        // 设置tab固定时的top位置
        this.setTabPosition($headerWrpper, $tabBox);

        // 切换tab栏active项
        this.toggleActieTab($productTab, $sectionList, $productTabContainer);
        
      }
    }

    if (!window.customElements.get('yg-tab')) {
      window.customElements.define('yg-tab', Tab);
    }
    class YGAddToCartButton extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('button.yg-add-to-cart');
        const submitBtn = document.querySelector('.buy-buttons button[type="submit"]');

        if (button && submitBtn) {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            submitBtn.click(); 
          });
        }
      }
    }
    customElements.define('yg-add-to-cart-button', YGAddToCartButton);
  });

function triggerAddToCart() {
    const addToCartButton = document.querySelector('.yg-buy-buttons button[type="submit"]');
    if (addToCartButton) {
      addToCartButton.click();
    } else {
      // 如果找不到按钮，尝试触发表单提交
      const productForm = document.querySelector('form[is="product-form"]');
      if (productForm) {
        productForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    }
  }
